import { useGetOrganizationId } from '@/hooks/useGetOrganizationId';
import { useGetOrganizationAdditionalInfoQuery } from '@/redux/slices/organizationApiSlice';
import { ABMEnrollmentStatusEnum } from '@electricjs/core_entity-client';

const useIsABMStatusUnknown = () => {
  const organizationId = useGetOrganizationId();

  const {
    data: orgAdditionalInfoData,
    isFetching: isFetchingOrgAdditionalInfoData,
  } = useGetOrganizationAdditionalInfoQuery({ organizationId });

  // While loading, treat as unknown to prevent premature submission
  if (isFetchingOrgAdditionalInfoData) {
    return true;
  }

  const abmStatus = orgAdditionalInfoData?.abmStatus;

  // Only return false for explicitly known good statuses
  switch (abmStatus) {
    case ABMEnrollmentStatusEnum.Connected:
    case ABMEnrollmentStatusEnum.Unconnected:
    case ABMEnrollmentStatusEnum.NotApplied:
      return false;
    case ABMEnrollmentStatusEnum.Unknown:
    default:
      // Treat undefined, null, or any unexpected value as unknown
      return true;
  }
};

export default useIsABMStatusUnknown;
